import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  MenuItem,
  TextField,
  Typography,
} from '@mui/material'
import './ActionBar.css'
import { EditOutlined } from '@mui/icons-material'
import { useState } from 'react'
import { shipToType } from './orderTypes'

export default function ActionBar(props: {
  totalCount: number
  selectedCount: number
  onBulkEditShippingAddress: (addressId: number) => void
  shippingAddresses: (shipToType & { id: number })[]
}) {
  const [open, setOpen] = useState(false)
  const [shippingAddress, setShippingAddress] = useState('')

  return (
    <div className={`action-bar${props.selectedCount === 0 ? ' action-bar--hidden' : ''}`}>
      <Typography variant="h6">
        {props.selectedCount} of {props.totalCount} selected
      </Typography>
      <Divider orientation="vertical" flexItem />
      <Button variant="text" color="inherit" startIcon={<EditOutlined />} size="large" onClick={() => setOpen(true)}>
        Bulk Edit
      </Button>

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm" className="action-bar-edit-dialog">
        <DialogTitle variant="h6">Bulk Edit</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            {props.selectedCount > 1 ? `${props.selectedCount} items have` : '1 item has'} been selected for bulk edit.
          </Typography>
          <TextField
            label="Ship to Address"
            value={shippingAddress}
            onChange={e => setShippingAddress(e.target.value)}
            select
            fullWidth
            size="small"
          >
            {props.shippingAddresses.map(address => (
              <MenuItem key={address.id} value={String(address.id)}>
                {[
                  address.ShipToAttention,
                  address.ShipToCompany,
                  address.ShipToAddress1,
                  address.ShipToAddress2,
                  address.ShipToAddressCity,
                  address.ShipToAddressState,
                  address.ShipToAddressZip,
                  address.ShipToAddressCountry,
                ]
                  .filter(Boolean)
                  .join(' ')}
              </MenuItem>
            ))}
          </TextField>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={() => setOpen(false)}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              if (shippingAddress !== '') {
                props.onBulkEditShippingAddress(parseInt(shippingAddress, 10))
              }
              setShippingAddress('')
              setOpen(false)
            }}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
